import { render, staticRenderFns } from "./AppNotice.vue?vue&type=template&id=279e66b6&scoped=true"
import script from "./AppNotice.vue?vue&type=script&lang=js"
export * from "./AppNotice.vue?vue&type=script&lang=js"
import style0 from "./AppNotice.vue?vue&type=style&index=0&id=279e66b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279e66b6",
  null
  
)

export default component.exports